import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { categoriesArrayPropTypes } from 'helpers/propTypes';

import LogoContainer from 'containers/LogoContainer';

import paymentImage from './assets/icons_payment.png';
import './Footer.scss';

const Footer = (props) => {
  const { marcasHome, subCategoriesHome, client } = props;

  const year = new Date().getFullYear();

  const scrollToTop = () => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

  return (
    <footer className={`footer${client?.design !== 1 ? '-sandy' : ''}`} data-testid="footer">
      <div>
        <div className="row footer-top">
          <div className="col-lg-1 col-md-12" />
          <div className="col-lg-10 footer-column">
            <div className="row">
              <div className="col-3 col-md-3 footer-column">
                <span className="title">Secciones</span>
                <ul>
                  <li><Link to="/home">Homepage</Link></li>
                  <li><Link to="/contacto">Nosotros</Link></li>
                  <li><Link to="/preguntas-frecuentes">FAQs frecuentes</Link></li>
                  <li><Link to="/contacto">Contacto</Link></li>
                  <li><Link to="/contacto">Local</Link></li>
                </ul>
              </div>
              <div className="col-3 col-md-3 footer-column">
                <span className="title">Marcas</span>
                <ul>
                  {marcasHome ? marcasHome.map((marca) => (
                    <li><Link to={`/productos/${marca.category.code}`}>{marca.category.name}</Link></li>
                  )) : <></>}
                </ul>
              </div>
              <div className="col-3 col-md-3 footer-column">
                <span className="title">Productos</span>
                <ul>
                  {subCategoriesHome ? subCategoriesHome.map((subCategory) => (
                    <li><span href={() => false}>{subCategory.category.name}</span></li>
                  )) : <></>}
                </ul>
              </div>
              <div className="col-3 col-md-3 footer-column">
                {/* <LogoContainer /> */}
                <span className="title">Sigamos Conectados</span>
                <ul>
                  <li><span>
                    {!!client && client.description}
                    </span>
                  </li>
                  <li className="social-links">
                    <a href={!!client && client.link_fb} target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-facebook" />
                    </a>
                    <a href={!!client && client.link_ig} target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-instagram" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-wrap d-md-flex">
          <div className="bottom col-lg-4">
            &copy;
            {' '}
            {year}
            {' '}
            {client ? client.name_show:null}, Inc.
          </div>
          <div className="bottom col-lg-4">
          </div>
          <div className="bottom col-lg-4">
            <button className="scrollTop" onClick={scrollToTop} type="button">
              Ir al inicio
              <i className="fa fa-arrow-up" style={{ paddingLeft: '5px' }} aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
      <div className="jaypion col-lg-12">
        &copy;
        {' '}
        {year}
        {' '}
        Derechos reservados por&nbsp;
        <a href="https://info.jaypionba.com/" target="_blank" rel="noopener noreferrer">
          Jaypion
        </a>
      </div>
    </footer>
  );
};

const mapStateToProps = (state) => ({
  marcasHome: state.category.marcasHome,
  subCategoriesHome: state.subCategory.itemsHome,
  client: state.app.client,
});

Footer.propTypes = {
  marcasHome: categoriesArrayPropTypes.isRequired,
  subCategoriesHome: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default connect(mapStateToProps)(Footer);
